import React from "react";

function SortIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      data-name="Layer 1"
      viewBox="0 0 24 24"
    >
      <path d="M11.293 17.707L8 21V1a1 1 0 10-2 0v20l-3.293-3.293a.999.999 0 10-1.414 1.414l4.293 4.293c.39.39.902.585 1.414.585s1.024-.195 1.414-.585l4.293-4.293a.999.999 0 10-1.414-1.414zM22.707 6.293a.999.999 0 000-1.414L18.414.586C18.024.196 17.512 0 17 0s-1.024.195-1.414.585l-4.293 4.293a.999.999 0 101.414 1.414L16 2.999V23a1 1 0 102 0V3l3.293 3.293a.999.999 0 001.414 0z"></path>
    </svg>
  );
}

export { SortIcon };
